// socket events
module.exports = {
  socketEvents: {
    CONNECTION: "connection",
    DISCONNECT: "disconnect",

    JOIN_ROOM: "joinRoom",
    USER_ACTIVITY: "userActivity",

    NOTIFICATIONS: "notification",
    NOTIFICATIONS_FOR_PIN_MESSAGE: "pin_notification",
    NOTIFICATIONS_FOR_PIN_MESSAGE_CHANNEL: "pin_notification_channel",
    USER_TYPING_GET: "user_typing",
    NOTIFICATIONS_FOR_MSG_REACTION: "msg_reaction",
    NOTIFICATIONS_FOR_MSG_REACTION_CHANNEL: "msg_reaction_channel",
    REPLY_NOTIFICATIONS: "reply_notification",
    GET_NOTIFICATIONS: "get_notification",
    GET_UNREAD_NOTIFICATIONS: "get_unread_notification",
    READ_NOTIFICATIONS: "read_notification",

    SEND_MESSAGE: "send_message",
    CALL_INITIATED: "call_initiated",
    CALL_RECEIVED: "call_received",
    PIN_MESSAGE: "message_pinned",
    USER_TYPING: "user_typing",
    MSG_REACTION: "message_reaction",
    PIN_MESSAGE_CHANNEL: "message_pinned_channel",
    MSG_REACTION_CHANNEL: "message_reaction_channel",
    REPLY_NOTIFICATIONS: "reply_notification",
    DELETE_MESSAGE: "delete_message_chat",
    DELETE_MESSAGE_CHANNEL: "delete_message_chat_channel",

    DELETED_MESSAGE_N: "deleted_message_chat",
    DELETED_MESSAGE_CHANNEL_N: "deleted_message_channel",

    ADD_MEMBER: "addMember",

    CHANNEL_HEADER_MSG: "channelHeader",
    CHANNEL_HEADER_CHANNEL: "channelHeaderChannel",

    CHANNEL_HEADER_MSG_N: "channelHeaderUpdate",
    CHANNEL_HEADER_CHANNEL_N: "channelHeaderUpdateChannel",

    USER_UPDATES: "userUpdate",
    USER_UPDATED: "userUpdated",

    REMOVE_MEMBER: "remove_member",
    REMOVE_MEMBER_N: "removed_member",
    LEAVE_CHANNEL: "leaveMember",

    RENAME_CHANNEL: "rename_channel",
    RENAME_CHANNEL_N: "rename_channel_notification",

    CHANNEL_MEMBER_UPDATE: "channel_member_update",
    CHANNEL_MEMBER_UPDATE_N: "channel_member_update_notification",

    SEND_REPLY_MESSAGE: "send_reply_message",
    MESSAGE_SEEN: "message_seen",
    CHANNEL_MESSAGE_SEEN: "channel_message_seen",
    MESSAGES_READ_BY_USER: "messages_read_by_user",
    CHANNEL_MESSAGES_READ_BY_USER: "channel_messages_read_by_user",

    POLL_VOTE_CHANNEL: "poll_vote_channel",
    NOTIFICATIONS_FOR_POLL_VOTE_CHANNEL: "poll_vote_notification_channel",
  },
};
